import React from 'react';
import { Col, Row } from 'react-bootstrap';
import API from '../../config/config';

const ColorBar = (props: any) => {

  return (
    <div className="ColorBar-background">
      <div className="container-fluid">
        <div className="container">
          <h2 className="ColorBar-h2">{props.data.title}</h2>

          <Row xl={4} md={2} sm={2} xs={2}>
            {props.data.ColorBar.map((items: any, i: number) => {
              return (
                <Col key={i}>
                  <div className="ColorBar-flex-container">
                    <img className="ColorBar-img" src={API.baseUrl + items.colorImage.url} alt={`${i}`} />
                    <h5 className="ColorBar-h5">{items.colorName}</h5>
                  </div>
                </Col>
              );
            })}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default ColorBar;
